module.exports = __webpack_public_path__ + "static/img/charging-image2.3957cfcc.jpg";